import { useEffect, useState } from "react";
import { signal } from "@preact/signals-react";

import Dialog from "componentsv2/modal/Dialog";
import Button from "componentsv2/button/Button";
import { PlusCircleIcon } from "components/Icons";
import Dropdown from "componentsv2/form/Dropdown";
import Checkbox from "componentsv2/form/Checkbox";
import BasicTable from "componentsv2/table/BasicTable";
import { useStore } from "storev2/formStore";
import { useTable } from "storev2/tableStore";
import { layout as layoutRoom } from "../ModelRoomHouseKeep";
import TableCustomFilter from "componentsv2/experimental/TableCustomFIlter";
import SearchWidget from "componentsv2/widgets/SearchWidget";
import {
  MessageContainer,
  useMessage,
} from "componentsv2/experimental/Message";
import proxy from "api/proxy";

const recId = signal(null);
const openModal = signal(false);
const employeeData = signal(null);
const reset_all = signal(false);
const roomsSelected = signal(new Map());
const keyFilter = "hotel.housekeeping|null";

function FormSchedule({
  layout,
  onclickRow,
  handleOnClose,
  onSave,
  onSearchDomain,
  records,
}) {
  return (
    <div className="relative w-full">
      <div className="flex space-x-5">
        <Dropdown
          name="employee"
          label="company.employee.name"
          placeholder="Nombre de el empleado..."
          model="company.employee"
          data={employeeData}
          field={{ model: "company.employee" }}
        />
        <Checkbox
          name="reset_all"
          label="housekeeping.wizard_schedule.reset_all"
          data={reset_all}
        />
      </div>

      <div className="mt-3 space-y-2 ">
        <div className="flex space-x-2">
          <SearchWidget
            layout={layout}
            storeId={keyFilter}
            count={records?.length || 0}
            getDomain={() => []}
            setSearchDomain={onSearchDomain}
          />
          <TableCustomFilter
            layout={layout}
            storeId={recId.value}
          />
        </div>

        <BasicTable
          name="rooms"
          layout={layout}
          records={records}
          storeId={recId.value}
          onClickRow={onclickRow}
          recordStoreId={recId}
        />
      </div>

      <div className="pt-10 pb-3 sticky bottom-0 w-full pointer-events-none bg-gradient-to-t from-neutral-100 via-neutral-100/90 left-10">
        <div className="flex space-x-4 justify-center w-full mx-auto pointer-events-auto">
          <Button
            color="rose"
            content={"schedule.wizard_schedule.close"}
            size="w-[166px]"
            onClick={handleOnClose}
            outline={true}
          />
          <Button
            color="amber"
            content={"schedule.wizard_schedule.save"}
            size="w-[166px]"
            onClick={onSave}
            outline={true}
          />
        </div>
      </div>
    </div>
  );
}

function WizardScheduleEmployee() {
  const layout = layoutRoom();
  const { messages, warning, hide, success, clear } = useMessage();

  const { newRecord } = useStore();
  const { setTable } = useTable();
  const [records, setRecords] = useState([]);

  const storeTable = useTable((state) => state[recId.value]);

  useEffect(() => {
    if (storeTable?.records) {
      setRecords(storeTable.records);
    }
  }, [storeTable?.records]);

  function initReset() {
    reset_all.value = false;
    employeeData.value = null;
    roomsSelected.value = new Map();
  }

  async function getRooms(domain) {
    try {
      const id = await newRecord(layout);
      recId.value = id;
      const { data } = await proxy.search("hotel.room", domain || [], [
        "name",
        "code",
        "type_",
        "type_.name",
        "accommodation",
        "accommodation.name",
        "location.name",
        "location.rec_name",
        "cleaning_type.name",
        "state",
        "housekeeping.rec_name",
      ]);

      setTable({ layout, records: data || [], storeId: id, domain: false });
    } catch (error) {
      console.error("Error:", error);
    }
  }

  async function onSave() {
    if (roomsSelected.value.size === 0 && !reset_all.value) {
      warning("schedule.wizard_schedule.msg_room");
      return;
    }
    if (!employeeData.value && !reset_all.value) {
      warning("schedule.wizard_schedule.msg_employee");
      return;
    }
    const res = null;
    if (reset_all.value) {
      await proxy.methodCall({
        model: "hotel.room",
        method: "reset_all",
        args: [],
      });
    }

    const roomsIds = Array.from(roomsSelected.value.keys());
    if (roomsSelected.value.size > 0) {
      const args = {
        model: "hotel.room",
        ids: roomsIds,
        values: {
          housekeeping: employeeData.value?.id,
        },
      };
      await proxy.save(args);
    }

    if (res === null) {
      success(
        reset_all.value
          ? "schedule.wizard_schedule.msg_reset_ok"
          : "schedule.wizard_schedule.msg_schedule_ok",
      );
      roomsSelected.value = new Map();
      await getRooms([]);
    }
  }

  function handleOnClose() {
    initReset();
    getRooms([]);
    clear();
    openModal.value = false;
  }

  function onclickRow(record) {
    const newMap = new Map(roomsSelected.value);

    if (newMap.has(record.id)) {
      newMap.delete(record.id);
    } else {
      newMap.set(record.id, record);
    }
    roomsSelected.value = newMap;
  }

  useEffect(() => {
    if (openModal.value) {
      initReset();
      getRooms([]);
      clear();
    }
  }, [openModal.value]);

  return (
    <div>
      <Button
        onClick={() => (openModal.value = true)}
        style=""
        content={"schedule.wizard_schedule.create"}
        color="blue"
        size="w-max"
        iconLeft={<PlusCircleIcon className="fill-current w-6 h-6" />}
      />
      <Dialog
        openModal={openModal}
        handleClose={() => (openModal.value = false)}
        title={"schedule.wizard_schedule.title"}
      >
        <FormSchedule
          layout={layout}
          onclickRow={onclickRow}
          handleOnClose={handleOnClose}
          onSave={onSave}
          records={records}
          onSearchDomain={(searchPart) => getRooms(searchPart || [])}
        />
        <div>
          <MessageContainer
            messages={messages}
            onMessageClose={hide}
            position="top-center"
          />
        </div>
      </Dialog>
    </div>
  );
}

export default WizardScheduleEmployee;
